import { createContext, useContext, useEffect, useRef, useState } from "react";

const LastRouteContext = createContext(null);

export const LastRouteProvider = ({ children }) => {
  const prevPathRef = useRef(null);
  const [lastRoute, setLastRoute] = useState(null);

  useEffect(() => {
    const updateRoute = () => {
      const currentPath = window.location.pathname + window.location.search + window.location.hash;

      if (prevPathRef.current !== null) {
        setLastRoute(prevPathRef.current);
      }

      prevPathRef.current = currentPath;
      window.parent?.postMessage(
        {
          type: "IFRAME_ROUTE_CHANGE",
          path: currentPath,
        },
        "*",
      );
    };

    // Initial set
    updateRoute();

    // Listen to browser navigation (back/forward)
    window.addEventListener("popstate", updateRoute);

    // Patch pushState & replaceState to detect route changes
    const originalPush = window.history.pushState;
    const originalReplace = window.history.replaceState;

    window.history.pushState = function (...args) {
      originalPush.apply(this, args);
      updateRoute();
    };

    window.history.replaceState = function (...args) {
      originalReplace.apply(this, args);
      updateRoute();
    };

    return () => {
      window.removeEventListener("popstate", updateRoute);
      window.history.pushState = originalPush;
      window.history.replaceState = originalReplace;
    };
  }, []);

  return <LastRouteContext.Provider value={lastRoute}>{children}</LastRouteContext.Provider>;
};

export const useLastRoute = () => useContext(LastRouteContext);
